import React, { useState } from "react";
import { useSelector } from "react-redux";
import { i18n } from "../../../private/languageSelector";
import { StoreAddressDialog } from "./StoreAddressDialog";
import { formatStoreAddress, getStoreAddressDisplay } from "./storeAddress";

/**
 * Store Address in the Add / Edit Store form: shows the saved address and opens the address popup.
 * addressDetails is the structured address (null for a store that only has a legacy free-text
 * address, which is shown as is until the user saves a structured one).
 *
 * onChange(addressDetails, formattedAddress) is called only when the popup is saved.
 */
export function StoreAddressField({ addressDetails, legacyAddress, error, onChange }) {
  const [open, setOpen] = useState(false);
  const { language } = useSelector((state) => state.auth);
  const display = getStoreAddressDisplay(addressDetails, legacyAddress);
  const isLegacy = !addressDetails && !!display;

  const onKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      setOpen(true);
    }
  };

  return (
    <>
      <div className="store-small-text-normal" id="store-address-label">
        {i18n("StoreAddress.Title")}
      </div>
      <div
        role="button"
        tabIndex={0}
        aria-labelledby="store-address-label"
        aria-haspopup="dialog"
        data-testid="store-address-field"
        className={`form-control p-0 d-flex align-items-center ${error ? "is-invalid" : ""}`}
        style={{ cursor: "pointer", height: "auto", minHeight: "calc(1.5em + 1.3rem + 2px)" }}
        onClick={() => setOpen(true)}
        onKeyDown={onKeyDown}
      >
        <span className="flex-grow-1" style={{ color: display ? "#333333" : "#B5B5C3", wordBreak: "break-word" }}>
          {display || i18n("StoreAddress.Placeholder")}
        </span>
      </div>
      {isLegacy && <span className="tax-number-text">{i18n("StoreAddress.LegacyHint")}</span>}
      {error && <div className="invalid-feedback d-block">{error}</div>}

      <StoreAddressDialog
        show={open}
        address={addressDetails}
        onCancel={() => setOpen(false)}
        onSave={(details) => {
          setOpen(false);
          onChange(details, formatStoreAddress(details));
        }}
      />
    </>
  );
}
